import dateFormatType from '@/constants/dateFormatType';
import { formatDate } from '@/utils';
import { addDays } from 'date-fns';
/**
 * 라이더공지사항 등록 폼데이터
 */
export class FormDataWorkerNotice {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _distributorId = '';
    get distributorId() {
        return this._distributorId;
    }
    set distributorId(value) {
        this._distributorId = value;
    }
    _hubId = '';
    get hubId() {
        return this._hubId;
    }
    set hubId(value) {
        this._hubId = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    /** 기간 선택 */
    _periodType = 'ALL';
    get periodType() {
        return this._periodType;
    }
    set periodType(value) {
        this._periodType = value;
    }
    /** 일자 */
    _selectedDate = [
        formatDate(new Date(), dateFormatType.DATE),
        formatDate(addDays(new Date(), 1), dateFormatType.DATE),
    ];
    get selectedDate() {
        return this._selectedDate;
    }
    set selectedDate(value) {
        this._selectedDate = value;
    }
    /** 선택된 허브 */
    _selectedHub = 'ALL';
    get selectedHub() {
        return this._selectedHub;
    }
    set selectedHub(value) {
        this._selectedHub = value;
    }
    /** 라이더 전체 여부 */
    _targetType = 'ALL';
    get targetType() {
        return this._targetType;
    }
    set targetType(value) {
        this._targetType = value;
    }
    /** 선택한 라이더 리스트 */
    _selectedWorkerList = [];
    get selectedWorkerList() {
        return this._selectedWorkerList;
    }
    set selectedWorkerList(value) {
        this._selectedWorkerList = value;
    }
    constructor(data) {
        if (!data) {
            return;
        }
        // 여기서 domain-model을 form에 맞게 변경
        Object.assign(this, data);
    }
}
